export default __webpack_public_path__ + "static/media/sim_logo.decd933a.jpg";